'use client';

import PartnersHero from '@/components/PartnersHero/PartnersHero';
import PartnersGrid from '@/components/PartnersGrid/PartnersGrid';

export default function PartnersClient() {
  return (
    <main id="main-content">
      <PartnersHero />
      <PartnersGrid />
    </main>
  );
}
